import {
  ArrowPathIcon,
  CheckIcon,
  ViewfinderCircleIcon,
  XMarkIcon
} from "@heroicons/react/20/solid";
import {
  SCAN_STATE_CURRENT,
  SCAN_STATE_GA170, SCAN_STATE_OTHER, SCAN_STATE_WAITING
} from "../../../services/live-interface/dior/dior-interface-service";


export const DiorScanState = ({ scanState }) => {
  const bgColor = scanState === SCAN_STATE_CURRENT ? 'border-perception-blue'
    : scanState === SCAN_STATE_GA170 ? 'border-perception-success-300' : 'border-perception-black-500';

  return (
    <div className={`w-full h-48 min-h-48 flex flex-col justify-center items-center gap-4 text-xl rounded-md bg-perception-black-500 border-4 ${bgColor}`}>
      {
        scanState === SCAN_STATE_CURRENT ?
          <>
            <ViewfinderCircleIcon aria-hidden="true" className="size-16 text-perception-blue" />
            <div className="text-perception-blue">
              Scanning...
            </div>
          </>
        : scanState === SCAN_STATE_GA170 ?
          <>
            <CheckIcon aria-hidden="true" className="size-16 text-perception-success-300" />
            <div className="text-perception-success-300">
              Process GA170 identified
            </div>
          </>
        : scanState === SCAN_STATE_WAITING ?
          <>
            <ArrowPathIcon aria-hidden="true" className="size-16" />
            <div>
              Please wait before scanning the next rack...
            </div>
          </>
        : scanState === SCAN_STATE_OTHER ?
          <>
            <XMarkIcon aria-hidden="true" className="size-16" />
            <div>
              Non managed process identified
            </div>
          </>
        :
          <>
            <ViewfinderCircleIcon aria-hidden="true" className="size-16 text-perception-gray-700" />
            <div className="text-perception-gray-700">
              Waiting for a cart to scan...
            </div>
          </>
      }
    </div>
  );
};